
import { defineComponent, PropType } from 'vue'
import { VulnerabilityOccurrenceReachability } from '~/types/types'

export default defineComponent({
  name: 'ReachabilityIndicator',
  props: {
    reachability: {
      type: String as PropType<VulnerabilityOccurrenceReachability>,
      default: ''
    }
  },
  computed: {
    label(): string {
      if (this.reachability === undefined) return 'Unknown'
      return {
        [VulnerabilityOccurrenceReachability.Reachable]: 'Reachable',
        [VulnerabilityOccurrenceReachability.Unreachable]: 'Unreachable',
        [VulnerabilityOccurrenceReachability.Unknown]: 'Unknown'
      }[this.reachability]
    },
    icon(): string {
      if (this.reachability === undefined) return 'map-pin-dash-inside'
      return {
        [VulnerabilityOccurrenceReachability.Reachable]: 'map-pin-check-inside',
        [VulnerabilityOccurrenceReachability.Unreachable]: 'map-pin-cross-inside',
        [VulnerabilityOccurrenceReachability.Unknown]: 'map-pin-dash-inside'
      }[this.reachability]
    }
  }
})
